<template>
  <div class="aboutus" id="aboutus">
    <h2>{{ about.aboutTitle }}</h2>

    <template v-for="(section, index) in sections">
      <div v-if="index > 0" :key="`divider-${index}`" class="aboutus__divider"></div>

      <div
        :key="index"
        class="aboutus__section aboutus__flex"
        :class="{ aboutus__flexreverse: index % 2 === 1 }"
      >
        <img class="aboutus__image" :src="section.image" :alt="section.alt" />

        <div class="aboutus__text">
          <h3>{{ section.title }}</h3>
          <br />

          <p>
            {{ section.text }}
          </p>
        </div>
      </div>
    </template>

    <Tryfree
      :register="register"
      :showDisclaimer="true"
      :alignCenter="true"
    />

    <div class="aboutus__faq">
      <h2>{{ about.faqLinkTitle }}</h2>
      <p>{{ about.faqLinkSubtitle }}</p>
    </div>

    <OrangeButton
      :label="about.faqLinkButton"
      :destination="{ path: 'faq' }"
      :alignCenter="true"
    />
  </div>
</template>

<script>
import Tryfree from "@/components/Tryfree.vue";
import OrangeButton from "@/components/Orangebutton.vue";

const ALTS = [
  "Matrett",
  "Tilberedning av mat",
  "Overlevering av mat",
  "Sjåfør i bil",
];

export default {
  components: {
    Tryfree,
    OrangeButton,
  },
  props: {
    about: Object,
    register: Object,
  },
  computed: {
    sections() {
      return ALTS.map((alt, index) => ({
        alt,
        title: this.about[`aboutSection${index + 1}Title`],
        text: this.about[`aboutSection${index + 1}Text`],
        image: this.about[`image${index + 1}`].url,
      }));
    },
  },
};
</script>

<style lang="scss">
.aboutus {
  width: 100%;
  max-width: 1300px;
  margin: auto;
  padding-top: 7.5rem;
  margin-top: -5rem;
  margin-bottom: 5rem;

  &__flex {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3rem;
    flex-wrap: wrap;
  }

  &__flexreverse {
    flex-direction: row-reverse;
  }

  &__section {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  &__text {
    width: 545px;
  }

  &__image {
    width: 100%;
    max-width: 550px;
    border-radius: 17px;
  }

  h2 {
    text-align: center;
  }

  &__divider {
    border: 1px solid #eae7dd;
    width: 100%;
    max-width: 1300px;
  }

  &__faq {
    margin-top: 8rem;
    margin-bottom: 2rem;
    text-align: center;
  }

  @media (max-width: $tablet) {
    padding: 0rem 1.18rem;
    padding-top: 7.5rem;
  }
}
</style>
